import styled from 'styled-components';
import { themeColor, ThemeColorName } from '../theme/colors';
import { xsRegular } from '../theme/typography';
import FiltersStyles from '../Filters/Filters.styles';

const TREE_COLOR: ThemeColorName = 'strokePrimary';
const TREE_HEIGHT = 36;

export const Container = styled.div.attrs({
  role: 'list',
})`
  ${xsRegular};
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 10px;

  &::before {
    content: '';
    position: absolute;

    top: 0;
    left: 0;
    height: calc(100% - ${TREE_HEIGHT / 2}px - 4px);
    width: 0px;
    border-left: 1px solid ${themeColor(TREE_COLOR)};

    z-index: 10;
  }
`;

export const TreeNodeContainer = styled.div.attrs({
  role: 'listitem',
})`
  position: relative;
`;

export const TreeNode = styled.div`
  display: flex;
  align-items: center;

  position: relative;
  height: ${TREE_HEIGHT}px;
  padding: 8px;
  padding-left: 18px;

  &::before {
    content: '';
    position: absolute;

    top: 50%;
    transform: translateY(-100%);

    left: 0;

    width: 14px;
    height: 6px;
    border-bottom-left-radius: 4px;
    border-left: 1px solid ${themeColor(TREE_COLOR)};
    border-bottom: 1px solid ${themeColor(TREE_COLOR)};
    z-index: 10;
  }
`;

export const ErrorFilter = styled(FiltersStyles.Container)`
  border-color: ${themeColor('red')};
`;
